import React from 'react';

const emptyBranch = () => ({ id: '', name: '', max_users: 1 });

const LicenseBranchesEditor = ({
  maxUsers,
  isMultiBranch,
  branches,
  onMultiBranchChange,
  onBranchesChange,
}) => {
  const allocated = (branches || []).reduce(
    (sum, b) => sum + (parseInt(b.max_users, 10) || 0),
    0
  );
  const cap = parseInt(maxUsers, 10) || 0;
  const totalsMatch = !isMultiBranch || allocated === cap;

  const updateBranch = (index, field, value) => {
    const next = (branches || []).map((branch, i) =>
      i === index ? { ...branch, [field]: value } : branch
    );
    onBranchesChange(next);
  };

  const addBranch = () => {
    onBranchesChange([...(branches || []), emptyBranch()]);
  };

  const removeBranch = (index) => {
    onBranchesChange((branches || []).filter((_, i) => i !== index));
  };

  return (
    <div className="card card-outline card-secondary mb-3">
      <div className="card-header py-2">
        <div className="form-check mb-0">
          <input
            type="checkbox"
            className="form-check-input"
            id="is_multi_branch"
            checked={Boolean(isMultiBranch)}
            onChange={(e) => {
              const checked = e.target.checked;
              onMultiBranchChange(checked);
              if (checked && (!branches || branches.length === 0)) {
                onBranchesChange([emptyBranch(), emptyBranch()]);
              }
              if (!checked) {
                onBranchesChange([]);
              }
            }}
          />
          <label className="form-check-label" htmlFor="is_multi_branch">
            <strong>Multi-branch license</strong>
          </label>
        </div>
      </div>
      {isMultiBranch ? (
        <div className="card-body py-3">
          <p className="text-muted mb-3">
            Allocate users per branch. Branch totals must equal Max Users ({cap || 0}).
            Branch names appear in ChesiWMS for users assigned to each branch.
          </p>
          {(branches || []).map((branch, index) => (
            <div className="row align-items-end mb-2" key={`${branch.id || 'new'}-${index}`}>
              <div className="col-md-6">
                <label>Branch name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. Nairobi DC"
                  value={branch.name || ''}
                  onChange={(e) => updateBranch(index, 'name', e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label>Users in branch</label>
                <input
                  type="number"
                  min="1"
                  className="form-control"
                  value={branch.max_users || ''}
                  onChange={(e) => updateBranch(index, 'max_users', e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-outline-danger btn-block"
                  onClick={() => removeBranch(index)}
                  disabled={(branches || []).length <= 1}
                >
                  <i className="fas fa-trash" />
                </button>
              </div>
            </div>
          ))}
          <button type="button" className="btn btn-sm btn-outline-secondary mt-2" onClick={addBranch}>
            + Add branch
          </button>
          <div className={`mt-2 small ${totalsMatch ? 'text-muted' : 'text-danger'}`}>
            Allocated {allocated} of {cap} users
            {totalsMatch ? '' : ' — totals must match Max Users before saving.'}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default LicenseBranchesEditor;
